<template>
  <v-btn
    :icon
    :to
    size="36"
    active-color="secondary"
    class="navigation-button"
    v-tooltip="{ text: title, openDelay: 500 }"
  />
</template>

<script lang="ts" setup>
import type { PropType } from 'vue'
import type { RouteLocationRaw } from 'vue-router'

defineProps({
  icon: {
    type: String,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  to: {
    type: [String, Object] as PropType<RouteLocationRaw>,
    required: true,
  },
})
</script>

<style lang="css" scoped>
.navigation-button {
  --v-activated-opacity: 0;
  transition: none;
}
</style>
